export default {
    meta: {
        titleTemplate: "Social Economy Month",
        description:
            "During the month of November, learn about social economy and how it economically and socially benefits communities across Québec.",
    },
    global: {
        date: "1<sup>st</sup> to 30<sup>th</sup> of November",
        pressKit: "Press kit",
        gotQuestions: "For all questions",
    },
    btn: {
        more: "Read more",
        discover: "Discover ",
        allEconomies: "All types of Economies",
        allStories: "Back",
        downloadKit: "Download kit",
        storyBehind: "Read the story",
    },
    shared: {
        locales: {
            en: "English",
            fr: "French",
        },
        cursor: {
            watch: "Play",
        },
        direction: "Tourist map",
    },
};
